// CHARLOTTE SHAPE - experimental mobile product app-like scroll.
(function () {
  "use strict";

  var MOBILE_QUERY = "(max-width: 699px)";
  var ROOT_ACTIVE_CLASS = "charlotte-product-app-scroll-active";
  var mediaQuery = window.matchMedia(MOBILE_QUERY);
  var main = null;
  var ticking = false;
  var enabled = false;
  var resizeObserver = null;

  function isProductPageReady() {
    return Boolean(
      document.body &&
        document.getElementById("main") &&
        document.querySelector(".shopify-section--main-product")
    );
  }

  function getViewportHeight() {
    return Math.round(window.visualViewport ? window.visualViewport.height : window.innerHeight);
  }

  function getHeaderOffset() {
    var headerSections = Array.from(document.querySelectorAll(".shopify-section-group-header-group"));

    return headerSections.reduce(function (bottom, section) {
      var style = window.getComputedStyle(section);

      if (style.display === "none" || style.visibility === "hidden") {
        return bottom;
      }

      var rect = section.getBoundingClientRect();

      if (rect.height <= 0) {
        return bottom;
      }

      return Math.max(bottom, rect.bottom);
    }, 0);
  }

  function writeViewportVars() {
    var headerOffset = Math.max(0, Math.round(getHeaderOffset()));
    var viewportHeight = getViewportHeight();

    document.documentElement.style.setProperty("--charlotte-product-app-scroll-top", headerOffset + "px");
    document.documentElement.style.setProperty("--charlotte-product-app-scroll-height", viewportHeight + "px");
  }

  function requestUpdate() {
    if (ticking) {
      return;
    }

    ticking = true;

    window.requestAnimationFrame(function () {
      ticking = false;
      writeViewportVars();
    });
  }

  function enable() {
    if (enabled || !mediaQuery.matches || !isProductPageReady()) {
      return;
    }

    main = document.getElementById("main");
    enabled = true;
    writeViewportVars();

    var startingScroll = Math.max(window.scrollY || 0, main.scrollTop || 0);
    document.documentElement.classList.add(ROOT_ACTIVE_CLASS);

    if (startingScroll > 0) {
      main.scrollTop = startingScroll;
      window.scrollTo(0, 0);
    }

    main.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate, { passive: true });
    window.addEventListener("orientationchange", requestUpdate);

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", requestUpdate, { passive: true });
    }

    if ("ResizeObserver" in window) {
      resizeObserver = new ResizeObserver(requestUpdate);
      document.querySelectorAll(".shopify-section-group-header-group").forEach(function (section) {
        resizeObserver.observe(section);
      });
    }

    requestUpdate();
  }

  function disable() {
    if (!enabled) {
      return;
    }

    var scrollTop = main ? main.scrollTop : 0;

    document.documentElement.classList.remove(ROOT_ACTIVE_CLASS);

    if (main) {
      main.removeEventListener("scroll", requestUpdate);
    }

    window.removeEventListener("resize", requestUpdate);
    window.removeEventListener("orientationchange", requestUpdate);

    if (window.visualViewport) {
      window.visualViewport.removeEventListener("resize", requestUpdate);
    }

    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }

    document.documentElement.style.removeProperty("--charlotte-product-app-scroll-top");
    document.documentElement.style.removeProperty("--charlotte-product-app-scroll-height");

    enabled = false;
    main = null;

    if (scrollTop > 0) {
      window.scrollTo(0, scrollTop);
    }
  }

  function syncState() {
    if (mediaQuery.matches) {
      enable();
    } else {
      disable();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncState, { once: true });
  } else {
    syncState();
  }

  if (typeof mediaQuery.addEventListener === "function") {
    mediaQuery.addEventListener("change", syncState);
  } else if (typeof mediaQuery.addListener === "function") {
    mediaQuery.addListener(syncState);
  }
})();
